// extracted by mini-css-extract-plugin
export default {"mnImageDetailContent":"index_mnImageDetailContent__MUqYD","mnImageDetailContentWrap":"index_mnImageDetailContentWrap__xOPxa","close":"index_close__hHojN"};